<template>
  <div>
    <KitsShowcaseWithFilters
      :title="t('kits.index.browseTitle')"
      :subtitle="t('kits.index.browseSubtitle')"
      :categories="sortedKitLinks"
    />

    <div v-for="blockData in blocksData" :key="blockData?.id ?? ''">
      <GenericBlock
        :component-type="blockData?.__typename as string"
        :content="blockData"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import KitsShowcaseWithFilters from '~/components/kits/KitsShowcaseWithFilters.vue'
import { useStrapiPageSeo } from '~/composables/useStrapiPage'
import { useStrapiKitsListSummaries } from '~/composables/useStrapiKitsListSummaries'
import { convertLocaleIntoBCP47 } from '~/utils/localeHelpers'

const { t, locale } = useI18n()

const [{ data: kitsSummaries }, pageData] = await Promise.all([
  useStrapiKitsListSummaries(),
  useStrapiPage({
    slug: `box_${locale.value}`,
    locale: convertLocaleIntoBCP47(locale.value),
  }),
])

const sortedKitLinks = computed(() => {
  const list = kitsSummaries.value ?? []
  return [...list].sort((a, b) =>
    a.title.localeCompare(b.title, locale.value, { sensitivity: 'base' })
  )
})

const blocksData = computed(() => {
  const raw = pageData?.data?.value as
    | { pages?: Array<{ contents?: { id?: string; __typename?: string }[] }> }
    | undefined
  return raw?.pages?.[0]?.contents
})
definePageMeta({
  layout: 'default-max-screen',
  preloaderType: 'strapi',
})

useStrapiPageSeo({
  pageData,
})
</script>
